export default __webpack_public_path__ + "static/Ecom-01 1-079bf97496193b9df9ad29b831f8eea4.png";